import request from "@/utils/request.js";
//
export function list(params) {
  return request({
    url: "/isp/user/list",
    method: "get",
    params
  });
}

export function deletebyid(id) {
  return request({
    url: `/api/address/delete/${id}`,
    method: "DELETE"
  });
}
export function deleteiptbyid(id) {
  return request({
    url: `/api/address/delete/${id}`,
    method: "DELETE",
  });
}
// 修改地址基本信息
export function editAddr(data) {
  return request({
    url: `/infor/updatethaentgr`,
    method: "post",
    data
  });
}
// 新增地址基本信息
export function harvestaddress(data) {
  return request({
    url: `/api/address/edit`,
    method: "post",
    data
  });
}

// 地址列表
export function queryaddress(params) {
  return request({
    url: "/api/address/page",
    method: "get",
    params
  });
}

export function selectinformation(params) {
  return request({
    url: "​/infor​/selectinformation",
    method: "get",
    params
  });
}

// 修改企业用户信息
export function userSave(data) {
  return request({
    url: "/api/user/edit",
    method: "post",
    data
  });
}
// 修改个人用户信息
export function userSave00(params) {
  return request({
    url: "/api/user/edit",
    method: "post",
    data
  });
}
